import { useSelector } from "react-redux";

export function formatAddress(address, lga, state) {
  return [address, lga, state].filter((part) => part?.trim()).join(", ");
}

const _useAuth = () => {
  const { authUser } = useSelector(({ auth }) => auth) || {};
  const facilityAddress = formatAddress(
    authUser?.facility_address,
    authUser?.facility_lga,
    authUser?.facility_state
  );

  return {
    authUser,
    facilityAddress,
    facilityName: authUser?.facility_name || "",
    institutionName: authUser?.institution_name || "",
    facilityId: authUser?.facility || null,
    userProgramRoles: authUser?.programs_roles || null,
    userRoles: authUser?.programs_roles?.map((role) => role.roles) || null,
    userLocationId: authUser?.user_location || null,
    userLocationName: authUser?.user_location_name || null,
    userStateId: authUser?.states || null,
    userStateName: authUser?.state_name || null,
    userLgaId: authUser?.lga || null,
    userDepartmentId: authUser?.department || null,
  };
};

export default _useAuth;
